import React from 'react';

const PrimaryTitle = (props) => {
    return (
        <h1 className={'primary-title'} style={!!props && !!props.style ? props.style : {}}>{props.children}</h1>
    );
}

export default PrimaryTitle;
